module.exports = __webpack_public_path__ + "media/images/riders/small/ONDREJ_CINK-51009320e51dc964e2ac48f6433f1c1d.png";